import * as Actions from '../actions/inviteusers.actions';
import * as Constants from '../actions/inviteusers.constants';
import { InviteUsersState } from '../types/inviteusers-state';

const defaultState: Partial<InviteUsersState> = {
  loading: false,
  message: '',
  organisations: [],
  selectedOrganisationId: undefined,
  list: [],
  complete: false
};

export function reducer(
  state: Partial<InviteUsersState> = defaultState,
  action: Actions.All
): Partial<InviteUsersState> {

  switch (action.type) {
    case Constants.INITIALIZE:
    case Constants.DESTROY: {
      return { ...defaultState };
    }
    case Constants.SET_ERROR_MESSAGE: {
      const { message } = action as Actions.SetErrorMessageAction;
      return { ...state, loading: false, message };
    }
    case Constants.UPDATE_SELECTED_ORGANISATION_ID: {
      const { id } = action as Actions.UpdateSelectedOrganisationIdAction;
      return { ...state, selectedOrganisationId: id };
    }
    case Constants.LOAD_ORGANISATIONS: {
      return { ...state, loading: true };
    }
    case Constants.LOAD_ORGANISATIONS_DONE: {
      const { organisations } = action as Actions.LoadOrganisationsDoneAction;
      if (!state.selectedOrganisationId && organisations.length > 0) {
        return { ...state, organisations, selectedOrganisationId: organisations[0].id, loading: false };
      }
      return { ...state, organisations, loading: false };
    }
    case Constants.ADD_USER: {
      const { user } = action as Actions.AddUserAction;
      return { ...state, list: [...(state.list || []), user] };
    }
    case Constants.REMOVE_USER: {
      const { email } = action as Actions.RemoveUserAction;
      const index = (state.list || []).findIndex((user) => user.email === email);
      const newList = (state.list || []).slice(0, index).concat((state.list || []).slice(index + 1));
      return { ...state, list: newList };
    }
    case Constants.SUBMIT_INVITE: {
      return { ...state, loading: true };
    }
    case Constants.SUBMIT_INVITE_DONE: {
      return {
        ...defaultState,
        selectedOrganisationId: state.selectedOrganisationId,
        complete: true,
        organisations: state.organisations
      };
    }
    default:
      return state;
  }

}